import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import client from 'api/apiClient';
import { oldGloryBaseUrl } from 'config/apiConfig';
import { getDefaultCompanyId, merchantHistoryData } from 'utils/helpers';
export interface FilterTransactionDetails {
    title: string;
    balance: number | string;
    note: string;
    transactionDateTime: string;
    name?: string;
    username?: string;
    logoUrl?: string;
    status?: string;
    type?: string;
    transactionAmount?: number;
    totalFee?: number;
    trxId?: string;
}
interface User {
    name: string;
    username: string;
    imgUrl?: string;
}

interface Company {
    name: string;
    email: string;
    companyCode: string;
    logoUrl?: string;
}

interface TransactionAttributes {
    key: string;
    value: string;
}

export interface TransactionDetail {
    amount: number;
    totalFee?: number;
    confirmationCode: string;
    transactionDateTime: string;
    subject: string;
    type: string;
    consumer?: User;
    company?: Company;
    user?: User;
    transactionStatus?: string;
    filteredData?: any;
    attributes: TransactionAttributes[];
}
interface typesOfAccountActivity {
    dashboardRecords: TransactionDetail[];
    sendMoneyRecords: TransactionDetail[];
    loading: boolean;
    error: string | null;
}
const initialState: typesOfAccountActivity = {
    dashboardRecords: [],
    sendMoneyRecords: [],
    loading: false,
    error: null,
};

// type variable would be of ENUM type which would have two keys DASHBOARD, SEND_MONEY
export const fetchAccountActivity = createAsyncThunk(
    'accountActivity/fetchAccountActivity',
    async ({ filter, type }: { filter: any; type: string }, { getState }) => {
        const { dayFrom, dayTo, role, pageSize, offset = 0 } = filter;
        const state: any = getState();
        const defaultCompanyId = getDefaultCompanyId(state);
        const { user } = state || {};
        const { defaultContainerId } = user || 0;
        const { trxHistories }: any = await client.post(
            `${oldGloryBaseUrl}/merchant/history`,
            {
                dayFrom,
                dayTo,
                companyId: defaultCompanyId,
                role,
            },
            { conatinerId: defaultContainerId, pageSize, offset }
        );

        const transactions = trxHistories?.map((trx: any) => merchantHistoryData(trx));
        return { type, transactions };
    }
);

const accountActivitySlice = createSlice({
    name: 'accountActivitySlice',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(fetchAccountActivity.pending, (state) => {
            state.loading = true;
        });
        builder.addCase(fetchAccountActivity.fulfilled, (state, action) => {
            state.loading = false;
            if (!action.payload) return;
            const { transactions, type } = action.payload;
            if (type === 'dashboard') {
                state.dashboardRecords = transactions || [];
            } else {
                state.sendMoneyRecords = transactions || [];
            }
        });
        builder.addCase(fetchAccountActivity.rejected, (state) => {
            state.loading = false;
        });
    },
});
export default accountActivitySlice.reducer;
